import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
const INICIO_DO_DESTAQUE = '\u0001';
const FIM_DO_DESTAQUE = '\u0002';
/** Marca um valor para que `renderizarComDestaque` o exiba em negrito dentro de uma mensagem traduzida. */
export function destacar(valor) {
    return `${INICIO_DO_DESTAQUE}${String(valor)}${FIM_DO_DESTAQUE}`;
}
/** Converte os trechos marcados por `destacar` em `<strong>`; o restante permanece como texto. */
export function renderizarComDestaque(texto) {
    const partes = texto.split(new RegExp(`${INICIO_DO_DESTAQUE}(.*?)${FIM_DO_DESTAQUE}`));
    return partes.map((parte, indice) => indice % 2 === 1 ? _jsx("strong", { children: parte }, indice) : _jsx(Fragment, { children: parte }, indice));
}
/** Rótulo de um status de execução; valores desconhecidos são exibidos como recebidos. */
export function rotuloDoStatus(status, t) {
    switch (status) {
        case 'RUNNING':
            return t('ingestao.status.emExecucao');
        case 'SUCCESS':
            return t('ingestao.status.concluida');
        case 'PARTIAL':
            return t('ingestao.status.parcial');
        case 'FAILED':
            return t('ingestao.status.falhou');
        case 'CANCELLED':
            return t('ingestao.status.cancelada');
        case 'PENDING':
            return t('ingestao.status.pendente');
        default:
            return status;
    }
}
